import { Search } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconMagnifyingGlass(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <Search />
    </IconWrapper>
  );
}
